module.exports = __webpack_public_path__ + "img/Marisol-Gutierrez.4de0964e.png";